import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initEditBookingInfo } from '../initialState'

const editBookingInfoSlice = createSlice({
  name: 'editBookingInfo',
  initialState: initEditBookingInfo,
  reducers: {
    updateEditInfo: (state: any, action: PayloadAction<any>) => {
      return action.payload
    },
  },
})
export const editBookingAction = editBookingInfoSlice.actions
export default editBookingInfoSlice
